import React from 'react';
import {connect} from 'react-redux';
import {logoutAgency} from './../../actions/authenticationActions';
import {getHubBaseUrl} from "../../utils/configUtils";

class AgencyLogout extends React.Component {

    componentDidMount() {
        logoutAgency(this.props.match.params.forgetStore);
    }

    render() {
        if(this.props.isAgency) {
            return (
                <div className="container mx-auto mt-8">
                    Logging out. If this message is shown for more than a few seconds please reload the page.
                </div>
            )
        }

        return (
            <div className="container mx-auto mt-8">
                You have logged out of your Retail User session. Please visit the {' '}
                <a className="text-primary-dark underline" href={`${getHubBaseUrl()}authentication/SingleSignOnServlet`}>
                   login page
                </a>
                {' '}to log in again.
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {
        isAgency: state.agency.isAuthenticated,
    }
}

export default connect(mapStateToProps) (AgencyLogout);